<template>
    <div class="ticket-chat full-page" :class="detailVisible  && (ruolo == 'admin' || ruolo == 'dipendente') ? 'detail-visible' : 'detail-hidden'">
			<div class="hidden">
				<ButtonModalForm
					:dati="datiUtente"
					:struttura="strutturaUtente"
					:action="action_utente"
					:title="title_utente"
					stilestruttura="flex flex-col gap-3 w-full"
					id="form-utente"
					ref="modificaClienteForm"
					:testoconferma="$root.trans.salva"
					bottonesalvacontinua=""
					:testoannulla="$root.trans.annulla"
					:extraaction="extraaction_utente"
					:extradati="datiUtenteSelect"
					:extrastruttura="strutturaUtenteSelect">
					<span></span>
				</ButtonModalForm>
			</div>
      <Dialog v-model:visible="approvazioneDialogVisibile" modal :header="$root.trans.richiedi_approvazione || 'Richiedi approvazione'" :style="{ width: '40%' }">
        <div class="flex flex-col gap-4">
          <p>{{ $root.trans.richiedi_approvazione_email_placeholder || 'Inserisci email separate da virgola' }}</p>
          <textarea v-model="approvazioneEmails" class="w-full border rounded p-2" rows="3" :placeholder="$root.trans.richiedi_approvazione_email_placeholder || 'mario@example.com, giulia@example.com'"></textarea>
        </div>
        <div class="flex justify-end gap-2 mt-4">
          <Button type="button" :label="$root.trans.annulla" severity="secondary" @click="approvazioneDialogVisibile = false"></Button>
          <Button type="button" :label="$root.trans.richiedi_approvazione_invia || 'Invia'" icon="pi pi-send" @click="inviaRichiestaApprovazione"></Button>
        </div>
      </Dialog>

      <Dialog v-model:visible="editTicketVisibile" modal :header="'Modifica ticket'" :style="{ width: '50%' }" v-if="ruolo == 'admin' && !is_confermato && !readonly" pt:root:class="edit-ticket-modal">
        <FormInput
          :dati="editTicketInfo"
          :formlabel="editTicketLabel"
          idform="edit-ticket-form"

          :action="edit_ticket_azione"
          ref="modalinput">
        </FormInput>
        <div class="flex justify-center gap-2 mt-4 edit-actions">
          <Button type="button" icon="pi pi-times" :label="$root.trans.annulla.toLowerCase()" severity="secondary" @click="visible = false"></Button>
          <Button type="button" icon="pi pi-save" :label="$root.trans.salva" @click="$refs.modalinput.checkForm(0)"></Button>
        </div>
      </Dialog>
      <SeparaTicketModal
            :main_ticket="ticket"
            :ticket_uniti="ticket_figli_uniti"
            cancelText="Annulla"
            title="Dettaglio Ticket Uniti"
            ref="separa_ticket_modal"
            :show_button="false"
          ></SeparaTicketModal>
<Drawer v-model:visible="showDrawer" position="right" classes="!w-[45%] !bg-[#F0F0F0] relative chat-drawer allegatiDrawer">
  <div class="absolute top-[60px] left-0 w-full bg-white p-4 pt-0 pb-[20px] allegatiDrawerTitle ">
    Allegati
  </div>
  <div id="container_allegati_preview" class="flex gap-4 flex-wrap p-[20px] mt-[40px]">
      <div v-for="allegato in globalAllegati" :key="allegato.id" class="flex flex-col items-center gap-[20px] w-[93px] allegatoCard">
        <a target="_blank" class="w-full no-underline">
          <div @click.prevent="openAllegatoPreview(allegato)" class="w-full h-[112px] bg-white border border-gray-300 flex items-center justify-center overflow-hidden allegatopreview">
            <template v-if="isImage(allegato.nome)">
              <img :src="getAllegatoUrl(allegato.id, allegato.tabella, allegato)" :alt="allegato.nome" class="w-full h-full object-cover" />
            </template>
            <template v-else-if="isPdf(allegato.nome)">
              <i class="pi pi-file-pdf text-4xl text-red-500"></i>
            </template>
            <template v-else-if="isWord(allegato.nome) || isExcel(allegato.nome)">
              <i class="pi pi-file-word text-4xl text-blue-600"></i>
            </template>
            <template v-else>
              <a :href="allegato.url">
                <i class="pi pi-file text-4xl text-gray-400"></i>
              </a>
            </template>
          </div>
          <span class="text-sm text-center break-words max-w-[128px]">{{ allegato.nome }}</span>
        </a>
      </div>
  </div>
</Drawer>
<Dialog v-model:visible="showPreviewOverlay" modal :header="'Anteprima'" :style="{ width: '80vw', height: '80vh' }" pt:root:class="allegato-preview-dialog" @hide="closePreview">
  <template #header>
    <div class="bg-white flex justify-between w-full">
        <div class="flex gap-[8px]">
          <img :src="`/img-appalto/file_${selectedAllegato?.type || 'altro'}.png`"/>
          <div>
            <h5>{{  selectedAllegato?.nome }}</h5>
            <p>{{ ticket.numero_progressivo }} | {{ ticket.titolo }}</p>
          </div>
        </div>
        <i
            class="pi pi-times cursor-pointer !text-[13px]"
            @click="closePreview"
        ></i>
    </div>
  </template>
  <iframe :src="previewImageSrc" frameborder="0" style="width:100%; height:800px; margin-top: 40px;"></iframe>
</Dialog>
        <div id="thread-header" v-if="ruolo != 'assistenza'" >
            <div class="title" :class="readPriorita()">
                <PriorityDot :priorita="ticket.priorita"/>
                <div>
                    <h5>{{ ticket.titolo }}</h5>
                </div>
            </div>
            <div class="ticket-info">
                <div>
                    <b>{{ ticket.numero_progressivo }}</b>
                </div>
                <div>
                    <Tag :value="tagStatoValue()" :severity="tagStatoSeverity()"/>
                </div>
                <AssegnatariCircles
                  v-if="assegnatari && assegnatari.length"
                  :assegnatari="assegnatari"
                  :titolo_assegnatari="title_assegnatari"
                  :action_assegnatari="action_assegnatari"
                  :dati_assegnatari="dati_assegnatari"
                  :struttura_assegnatari="struttura_assegnatari"
                  />
                <div class="row gap-2">
                <div class="thread-actions">
                <Button v-if="richiedi_approvazione" type="button" icon="pi pi-check-circle" :label="$root.trans.richiedi_approvazione || 'Richiedi approvazione'" severity="warning" @click="approvazioneDialogVisibile = true" pt:root:class="richiedi-approvazione-btn" />
                <Button type="button" icon="pi pi-ellipsis-v" @click="toggleMenu" aria-haspopup="true" aria-controls="overlay_menu" pt:root:class="open-ticket-menu" v-if="ruolo=='admin' && !is_confermato && !readonly && !hide_chat && !hide_nota_interna"/>
                <Menu ref="menu" id="overlay_menu" :model="updateMenuItems" :popup="true" v-if="ruolo=='admin' && !is_confermato && !readonly && !hide_chat">
                  <template #item="{item, props}">
                    <div class="ticket-menu-item">

                      <img :src="'/img-appalto/'+item.icon+'.svg'" alt="" />
                      <span>
                        {{ item.label }}
                      </span>
                    </div>

                  </template>
                </Menu>
                  <i class="cursor-pointer thread-action-icon" :class="detailVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" @click="detailVisible = !detailVisible"></i>
                </div>
                </div>

            </div>

            <div id="ticket-details" v-if="detailVisible && (ruolo == 'admin' || ruolo == 'dipendente')">
                <div>
                    <div>
                        <p class="info-label">Tipologia</p>
                        <p class="info-answer">{{ ticket.tipo_ticket }}</p>
                    </div>
                    <div>
                        <p class="info-label">{{ isWhistleblowing ? 'Data scadenza riscontro' : 'SLA' }}</p>
                        <p class="info-answer">{{ ticket.sla || '-' }}</p>
                    </div>
                    <div>
                        <p class="info-label">{{ isWhistleblowing ? 'Data apertura' : 'Ore lavorate' }}</p>
                        <p class="info-answer">{{ isWhistleblowing ? (ticket.data_apertura || '-') : (ticket.ore_lavorate || '-') }}</p>
                    </div>
                    <div>
                        <p class="info-label">Ultimo aggiornamento</p>
                        <p class="info-answer">{{ ticket.ultimo_aggiornamento || '-' }}</p>
                    </div>
                </div>
                <div>
                    <div>
                      <div>
                          <p class="info-label">{{ isWhistleblowing ? 'Segnalante' : 'Utente' }}</p>
                          <p class="info-answer" v-if="isWhistleblowing">
                              {{ ticket.utente || $root.trans.anonimo }}
                            </p>
                          <p class="info-answer" v-else v-if="datiUtente">
                              {{ nomeUtente }} {{ cognomeUtente }}
                            </p>

                      </div>
                      <div>
                          <p class="info-label">Email</p>
                          <p class="info-answer">{{ ticket.email }} </p>
                      </div>
                      <div>
                          <p class="info-label">Telefono</p>
                          <p class="info-answer">{{ ticket.telefono || '-' }} </p>
                      </div>
                      <div>
                          <p class="info-label">{{ isWhistleblowing ? 'Canale' : 'interno' }}</p>
                          <p class="info-answer">{{ ticket.interno || '-' }} </p>
                      </div>
                      <div>
                          <p class="info-label">Organizzazione</p>
                          <a v-if="ruolo == 'admin' && ticket.ticketingcontratti_id" class="info-answer underline hover:underline" :href="getUrl('ticketing/contratti/dettaglio', ticket.ticketingcontratti_id)"><i class="pi pi-eye"></i> {{ ticket.organizzazione }}</a>
                      </div>
                    </div>
                </div>
                <div>
                    <template v-if="globalAllegati && globalAllegati.length > 0">
                        <p class="info-label">Allegati</p>
                        <div class="allegati-container">
                            <template v-for="(allegato, index) in globalAllegati.slice(0,3)" :key="index">
                                <a @click.prevent="openAllegatoPreview(allegato)" class="allegato-link mb-2">
                                    <i class="pi pi-paperclip"></i> {{ allegato.nome }}
                                </a>
                            </template>
                            <template v-if="globalAllegati.length > 3">
                              <span>...</span>
                            </template>
                            <a @click="showDrawer = true" class="mostratutti ">Mostra Tutti</a>
                        </div>

                    </template>
                </div>
            </div>
            <div id="ticket-details" v-else-if="detailVisible && ruolo === 'esterno'" >
              <div>
                <div>
                    <p class="info-label">Tipologia</p>
                    <template v-if="ruolo == 'admin' && !is_confermato">
                      <Select v-model="ticket.ticketingtipo_id" :options="tipo_select" name="tipologia" optionLabel="nome" optionValue="id" :placeholder="$root.trans.option_selezionare" class="w-full" @change="ticket_modificato = true" />
                    </template>
                    <template v-else>
                      <p class="info-answer">{{ ticket.tipo_ticket }}</p>
                    </template>
                </div>
                <div>
                  <p class="info-label">Data</p>
                  <p class="info-answer">{{ formatDateTime(ticket.creato) }}</p>
                </div>
                <div>
                  <p class="info-label">Utente</p>
                  <p class="info-answer">{{ ticket.utente }} </p>
                </div>
                <div>
                    <p  class="info-label">Email</p>
                    <p class="info-answer">{{ ticket.email }} </p>
                </div>
              </div>
              <div>
                <template v-if="globalAllegati && globalAllegati.length > 0">
                    <p class="info-label">Allegati</p>
                    <div class="allegati-container">
                        <template v-for="(allegato, index) in globalAllegati" :key="index">
                            <a :href="getAllegatoUrl(allegato.id, allegato.tabella, allegato)" target="_blank" class="allegato-link">
                                <i class="pi pi-paperclip"></i> {{ allegato.nome }}
                            </a>
                        </template>
                    </div>

                </template>
              </div>
            </div>


        </div>
        <div v-else id="thread-header">
          <div class="title" >
                <div>
                    <h3>{{ ticket.titolo }}</h3>
                </div>
          </div>
            <div class="ticket-info">
            </div>
            <div id="ticket-details" v-if="detailVisible">
              <!-- Colonna 1 info generali-->

              <div>
                  <div>
                      <b class="info-label">Modulo assistenza:</b>
                      <span>{{ ticket.modulo_nome }}</span>
                  </div>
                  <div>
                      <b  class="info-label">Ultimo aggiornamento:</b>
                      <span>{{ ticket.ultimo_aggiornamento }}</span>
                  </div>
              </div>
              <!-- Colonna 2 allegati-->
              <div>
                <template v-if="globalAllegati && globalAllegati.length > 0">
                      <b  class="info-label">Allegati:</b>
                      <div class="allegati-container">
                          <template v-for="(allegato, index) in globalAllegati.slice(0,3)" :key="index">
                              <a @click.prevent="openAllegatoPreview(allegato)" class="allegato-link">
                                  <i class="pi pi-paperclip"></i> {{ allegato.nome }}
                              </a>
                          </template>
                          <template v-if="globalAllegati.length > 3">
                            <span>...</span>
                          </template>
                          <a @click="showDrawer = true" class="mostratutti ">Mostra Tutti</a>
                      </div>

                  </template>
              </div>
            </div>
        </div>
        <div v-if="!hide_chat" class="messages-container" @scroll="messagesScroll" ref="messagesContainer">
            <!-- Messaggio principale del ticke -->
            <MessaggioChat :message="ticket" :ruolo="ruolo" />

            <a @click.prevent="scrollToForm" id="scrollToForm" v-if="showRispondi && !is_confermato">Rispondi <i class="pi pi-arrow-down"></i></a>
            <!-- Thread del ticket -->
            <template v-for="t in thread" :key="t.id">
              <MessaggioChat
                :message="t"
                :is-readonly="readonly"
                :edit_ore="ruolo === 'admin'"
                :step="step"
                :ruolo="ruolo"
                @ore_saved="update_ore_lavorate"
                />
            </template>

                <inner-thread-form-with-tabs
                  v-if="!is_confermato && !readonly && (ruolo != 'esterno' || (ruolo == 'esterno' && ruolo_utente_contratto == 2) || (ruolo == 'esterno' && esterno_can_edit_ticket == 1))"
                  :dati='dati_thread'
                  :struttura='struttura_thread'
                  :azione="action"
                  :annulla="annulla"
                  :linkriapertura="link_riapertura"
                  :hide_riapri="isWhistleblowing"
                  stilestruttura="grid grid-cols-1 md:grid-cols-2 gap-[20px]"
                  id="form"
                  :is_completato="is_completato"
                  :bottonesalva="bottonesalva"
                  :bottonesalvacontinua="bottonesalvacontinua"
                  :bottoneannulla="bottoneannulla"
                  :oretotali="oretotali"
                  :ruolo="ruolo"
                  :hide_nota_interna="hide_nota_interna"
                  ref="thread_form"
                  >
                </inner-thread-form-with-tabs>

            <div id="fixed-save" v-if="!is_confermato && !readonly && (ruolo != 'esterno' || (ruolo == 'esterno' && ruolo_utente_contratto == 2) || (ruolo == 'esterno' && esterno_can_edit_ticket == 1))" :class="{'has-riapri': is_completato && !isWhistleblowing && !hide_riapri}">
              <Button :label="$root.trans.salva" @click="save"></Button>
              <Button v-if="is_completato && !isWhistleblowing && !hide_riapri" :label="$root.trans.riapri_ticket" @click="$refs.thread_form.riapriTicket()" :disabled="$refs.thread_form && $refs.thread_form.isRiaprendo" class="riapri-btn"></Button>
            </div>
            <div id="fixed-save" v-if="readonly && !hide_concorrenza">
              <Button icon="pi pi-unlock" :label="$root.trans.prendi_controllo" @click="sblocca_ticket"></Button>
            </div>
        </div>

        <!-- Form assegnazione quando hide_chat è true (ruolo 1 CM) -->
        <div v-if="hide_chat" class="p-6">
            <div class="bg-white rounded-lg shadow p-6">
                <single-form
                  :dati='dati_thread'
                  :struttura='struttura_thread'
                  :azione="action"
                  annulla=''
                  stilestruttura="grid grid-cols-1 md:grid-cols-1 gap-3 w-1/3"
                  id="form-assegnazione"
                  :bottonesalva="bottonesalva"
                   bottonesalvacontinua=''
                   >
                </single-form>
            </div>
        </div>

        <!-- AI Assistant -->
        <AiAssistant
          :ticketMessage="ticket.messaggio_originale"
          :available_ai_models="ai_models_list"
          :ruolo="ruolo"
          :allegati="globalAllegati"
          v-if="JSON.parse(ai_models_list).length > 0"
        />
    </div>



</template>
<style>
  body div{
    background-color: initial;
  }
  body div.logo-work-quality p{
    color: white;
  }
</style>

<script>
import Button from 'primevue/button';
import Input from 'primevue/inputtext';
import Tag from 'primevue/tag';
import PriorityDot from './PriorityDot.vue';
import AssegnatariCircles from './AssegnatariCircles.vue';
import MessaggioChat from './MessaggioChat.vue';
import ButtonModalForm from './ButtonModalForm.vue';
import Card from 'primevue/card';
import Select from 'primevue/select';
import SeparaTicketModal from './SeparaTicketModal.vue';
import DatePicker from 'primevue/datepicker';
import Menu from 'primevue/menu';
import Dialog from 'primevue/dialog';
import FormInput from './FormInput.vue';
import Drawer from './Drawer.vue';
import AiAssistant from './AiAssistant.vue';
import {usePlan} from '../usePlan';

export default {
  name: 'Thread',
  components: {
    PriorityDot,
    AssegnatariCircles,
    MessaggioChat,
    Button,
    Input,
    Tag,
    ButtonModalForm,
    Card,
    Select,
    DatePicker,
    SeparaTicketModal,
    Menu,
    FormInput,
    Dialog,
    Drawer,
    AiAssistant


  },
  data(){
    return {
        ticket: this.main_ticket,
        thread: this.ticket_thread,
        assegnatari: this.ticket_assegnatari,
        datiUtente : this.dati_utente || null,
        strutturaUtente : this.struttura_utente || [],
        datiUtenteSelect : this.extradati_utente || {},
        strutturaUtenteSelect : this.extrastruttura_utente || [],
        tipo_select : this.tipologie ? JSON.parse(this.tipologie) : [],
        ticket_modificato : false,
        scadenza_modificata: false,
        detailVisible: true,
        showRispondi: true,
        ticket_figli_uniti: JSON.parse(this.ticket_figli) || [],
        globalAllegati:  this.allegati ? JSON.parse(this.allegati) : [],
        editTicketVisibile:false,
        showDrawer:false,
        showPreviewOverlay: false,
        previewImageSrc: '',
        selectedAllegato: null,
        updateMenuItems:[
          {
            label: 'Modifica Ticket',
            icon: 'editsquareicon',
            command: () => {
              this.$refs.menu.hide();
              this.editTicketVisibile = true;
            }
          },
          {
            label: 'Modifica Cliente',
            icon: 'editclienteicon',
            command: () => {
              this.$refs.menu.hide();
              this.$refs.modificaClienteForm.visible = true;
            }
          }
        ],
        editTicketInfo: {},
        editTicketLabel: {},
        nomeUtente: '',
        cognomeUtente: '',
        ai_models_list: "[]",
        isWhistleblowing: false,
        approvazioneDialogVisibile: false,
        approvazioneEmails: '',
        layoutResizeObserver: null,
        layoutResizeHandler: null

    }
  },
  props:[
    'main_ticket',
    'ticket_thread',
    'ticket_assegnatari',
    'is_confermato',
    'ruolo',
    // props per modifica utente
    'extraaction_utente',
    'extradati_utente',
    'extrastruttura_utente',
    'dati_utente',
    'struttura_utente',
    'action_utente',
    'title_utente',
    // props per form thread
    'dati_thread',
    'struttura_thread',
    'action',
    'annulla',
    'link_riapertura',
    'is_completato',
    'bottonesalva',
    'bottonesalvacontinua',
    'bottoneannulla',
    'oretotali',
    'title_assegnatari',
    'action_assegnatari',
    'dati_assegnatari',
    'struttura_assegnatari',
    'ticket_figli',
    'has_unione',
    'separazione_permessa',
    // prop per verificare se il thread è readonly
    'readonly',

    'allegati',
    // props per modifica ticket
    'tipologie',
    'step',
    'ruolo_utente_contratto',
    'info_ticket_form',
    'label_ticket_form',
    'edit_ticket_azione',
    'available_ai_models',
    'hide_concorrenza',
    'hide_chat',
    'hide_nota_interna',
    'richiedi_approvazione',
    'hide_riapri'

  ],
  beforeMount(){
    this.ai_models_list = this.available_ai_models ?? "[]";
  },
  beforeUnmount() {
    if (this.layoutResizeObserver) {
      this.layoutResizeObserver.disconnect();
      this.layoutResizeObserver = null;
    }
    if (this.layoutResizeHandler) {
      window.removeEventListener('resize', this.layoutResizeHandler);
      window.removeEventListener('menu-toggle', this.layoutResizeHandler);
      this.layoutResizeHandler = null;
    }
  },
  mounted(){
    const { can, planCode } = usePlan()
    console.log(can('ai_tecnici'))
    if(!can('ai_tecnici')) {
      this.ai_models_list = "[]";
    }
    console.log("Plan code:", planCode.value);
    this.ticket.messaggio = this.ticket.messaggio_originale
    this.ticket.tipo_post = "messaggio"
    this.ticket.avatar.ordine = "reverse";
    console.log(this.readonly)

    this.isWhistleblowing = String(this.ticket.modulo_nome || '').toLowerCase().includes('whistleblowing');
    if (this.isWhistleblowing && this.ticket && Array.isArray(this.ticket.allegati)) {
      // Per whistleblowing: non mostrare tutti gli allegati nel messaggio iniziale
      this.ticket.allegati = [];
    }

    if(this.ruolo == 'admin'){
      this.editTicketInfo = JSON.parse(this.info_ticket_form);
      this.editTicketInfo.ticketingutentiteam_id = this.assegnatari.map(a => a.ticketingutentiteam_id);
      this.editTicketLabel = JSON.parse(this.label_ticket_form);
    }

    // Solo se messagesContainer esiste (hide_chat è false)
    if(this.$refs.messagesContainer){
      const messageWindowElement = this.$refs.messagesContainer;
      const elementClientHeight = messageWindowElement.clientHeight;
      const elementScrollHeight = messageWindowElement.scrollHeight;

      if(elementClientHeight == elementScrollHeight || elementClientHeight + 200 > elementScrollHeight){
        this.showRispondi = false;
      }
      this.scrollToForm();
    }

    if(this.has_unione && this.separazione_permessa && this.ruolo == 'admin'){
      this.updateMenuItems.push({
        label: 'Separa Ticket',
        icon: 'unmergeicon-black',
        command: () => {
          this.$refs.menu.hide();
          this.$refs.separa_ticket_modal.visible = true;
        }
      });
    }

    console.log(this.thread)

    if(this.datiUtente){
      try{
        const parsedDatiUtente = JSON.parse(this.datiUtente);
        this.nomeUtente = parsedDatiUtente?.nome;
        this.cognomeUtente = parsedDatiUtente?.cognome;
      }catch(error){
        console.error("Errore nel parsing di datiUtente:", error);
      }
    }

    this.layoutResizeHandler = () => {
      this.$nextTick(() => {
        this.updateThreadLayoutHeights();
      });
    };

    window.addEventListener('resize', this.layoutResizeHandler);
    window.addEventListener('menu-toggle', this.layoutResizeHandler);

    this.$nextTick(() => {
      this.updateThreadLayoutHeights();
      this.observeThreadLayoutHeights();

      requestAnimationFrame(() => {
        this.updateThreadLayoutHeights();
      });

      setTimeout(() => {
        this.updateThreadLayoutHeights();
      }, 250);
    });
  },
  watch: {
    detailVisible() {
      this.$nextTick(() => {
        this.updateThreadLayoutHeights();
        this.observeThreadLayoutHeights();
      });
    }
  },
  methods:{
    updateThreadLayoutHeights() {
      const threadHeader = this.$el?.querySelector('#thread-header');
      const separaTicketCard = this.$el?.querySelector('#separa_ticket_card');

      document.documentElement.style.setProperty(
        '--thread-header-height',
        `${threadHeader ? threadHeader.getBoundingClientRect().height : 0}px`
      );

      document.documentElement.style.setProperty(
        '--separa-ticket-card-height',
        `${separaTicketCard ? separaTicketCard.getBoundingClientRect().height : 0}px`
      );
    },
    observeThreadLayoutHeights() {
      if (!window.ResizeObserver) {
        return;
      }

      if (this.layoutResizeObserver) {
        this.layoutResizeObserver.disconnect();
      }

      this.layoutResizeObserver = new ResizeObserver(() => {
        this.updateThreadLayoutHeights();
      });

      const threadHeader = this.$el?.querySelector('#thread-header');
      const separaTicketCard = this.$el?.querySelector('#separa_ticket_card');

      if (threadHeader) {
        this.layoutResizeObserver.observe(threadHeader);
      }

      if (separaTicketCard) {
        this.layoutResizeObserver.observe(separaTicketCard);
      }
    },
    toggleMenu(event){
        this.$refs.menu.toggle(event);
    },
    tagStatoValue(){
      const stato = this.ticket.stato.replace(/ /g, '_').toLowerCase();

      if(stato === 'aperto') {
        return this.$root.trans.stato_ticket_aperto;
      } else if(stato === 'in_lavorazione') {
        return this.$root.trans.stato_ticket_in_lavorazione;
      } else if(stato === 'in_attesa') {
        return this.$root.trans.stato_ticket_in_attesa;
      } else if(stato === 'in_attesa_del_cliente') {
        return this.$root.trans.stato_ticket_in_attesa_del_cliente;
      } else if(stato === 'completato') {
        return this.$root.trans.stato_ticket_completato;
      } else if(stato === 'confermato') {
        return this.$root.trans.stato_ticket_confermato;
      } else if(stato === 'incompleto'){
        return this.$root.trans.stato_ticket_incompleto;
      }else {
        return this.$root.trans.stato_ticket_sconosciuto;
      }
    },
    tagStatoSeverity(){
      const stato = this.ticket.stato.replace(/ /g, '_').toLowerCase();
      if(stato === 'aperto') {
        return 'contrast';
      } else if(stato === 'in_lavorazione') {
        return 'info';
      } else if(stato === 'in_attesa') {
        return 'warning';
      } else if(stato === 'in_attesa_del_cliente') {
        return 'warning';
      } else if(stato === 'completato') {
        return 'success';
      } else if(stato === 'confermato') {
        return 'success';
      } else if(stato === 'incompleto'){
        return 'danger';
      } else {
        return 'danger';
      }
    },
    readPriorita(){
     return `priority-${this.ticket.priorita.toLowerCase()}`;
    },
    getUrl(routeName, params) {
      return route(routeName, params);
    },
    getAllegatoUrl(id, type, allegato){
      if(allegato && allegato.url) return allegato.url;
      return route('ticketing/allegato', { id: id, tipo: type });
    },
    isImage(filename) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
      return imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
    },
    isPdf(filename) {
      return filename.toLowerCase().endsWith('.pdf');
    },
    isWord(filename) {
      const wordExtensions = ['.doc', '.docx'];
      return wordExtensions.some(ext => filename.toLowerCase().endsWith(ext));
    },
    isExcel(filename) {
      const excelExtensions = ['.xls', '.xlsx', '.csv'];
      return excelExtensions.some(ext => filename.toLowerCase().endsWith(ext));
    },
    isPdf(filename){
      const excelExtensions = ['.pdf'];
      return excelExtensions.some(ext => filename.toLowerCase().endsWith(ext));

    },
    openAllegatoPreview(allegato){
      this.selectedAllegato = allegato
      this.previewImageSrc = '';
      if(this.isImage(allegato.nome) || this.isPdf(allegato.nome)){
        if(this.isImage(allegato.nome)) this.selectedAllegato.type = 'img';
        if(this.isPdf(allegato.nome)) this.selectedAllegato.type = 'pdf';
        this.previewImageSrc = allegato.url;
        this.showPreviewOverlay = true;
      }else if(this.isWord(allegato.nome) || this.isExcel(allegato.nome)){
        if(this.isWord(allegato.nome)) this.selectedAllegato.type = 'pdf';
        if(this.isExcel(allegato.nome)) this.selectedAllegato.type = 'xls';
        this.previewImageSrc = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(allegato.url);
        this.showPreviewOverlay = true;
      }else{
        if(this.isPdf(allegato.nome)){
          this.selectedAllegato.type = 'pdf'
        }else{
          this.selectedAllegato.type = 'altro';
        };
        const url = this.getAllegatoUrl(allegato.id, allegato.tabella, allegato)
        window.open(url, '_blank');
      }
    },
    closePreview(){
      this.showPreviewOverlay = false;
      this.previewImageSrc = '';
      this.selectedAllegato = null;
    },
    scrollToForm(){
      const formElement = this.$refs.thread_form;
      if(formElement){
        formElement.$refs.tabsContainer.scrollIntoView({ behavior: 'smooth' });
      }
    },
    messagesScroll(e){
      const messageWindowElement = this.$refs.messagesContainer;
      const scrollTop = messageWindowElement.scrollTop;
      const scrollHeight = messageWindowElement.scrollHeight;
      const elementClientHeight = messageWindowElement.clientHeight;
      const formElement = this.$refs.thread_form.$refs.tabsContainer;
      const formHeight = formElement.clientHeight;

      if(scrollTop + elementClientHeight < scrollHeight - formHeight){
        this.showRispondi = true;
      }else{
        this.showRispondi = false;
      }
    },
    formatDateTime(value) {
      const date = new Date(value).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      const time = new Date(value).toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit'
      });
      return date + " " + time;
    },
    update_ore_lavorate(data){
      if(data.response.success){
        this.$toast.add({
          severity:'success',
          summary:"Success",
          detail: data.response.ok,
          life:5000
        });
        if(data.response.params && data.response.params.ore_lavorate_string){
          this.ticket.ore_lavorate = data.response.params.ore_lavorate_string;
        }
      }else{
        if (data.response.message != null) {
            this.$toast.add({
              severity: 'error',
              summary: this.$root.trans.errors_form,
              detail: this.$root.trans[data.response.message],
              life: 5000
            });
          } else {
            this.$toast.add({
              severity: 'error',
              summary: this.$root.trans.errors_form,
              detail: this.$root.trans.salvataggio_errato,
              life: 3000
            });
          }
      }

    },
    sblocca_ticket(){
      console.log('ora sblocco il ticket')
      const id = this.ticket.id;
      console.log(this.ruolo)
      axios.post(`/${this.ruolo}/ticketing/sblocca/${id}`)
      .then(response => {
        if(response.data.success){
          this.$toast.add({severity:'success', summary:this.$root.trans.ticket_sbloccato, life:5000});
          window.location.reload();
        }
      })
      .catch(error => {
        this.$toast.add({severity:'error', summary:this.$root.trans.ticket_sbloccato_fallito, life:5000});
      });
    },
    inviaRichiestaApprovazione(){
      axios.post('/admin/ticketing/richiedi-approvazione', {
        ticket_id: this.ticket.id,
        emails: this.approvazioneEmails
      })
      .then(response => {
        if(response.data.success){
          this.$toast.add({ severity: 'success', summary: 'Successo', detail: response.data.message, life: 4000 });
          this.approvazioneDialogVisibile = false;
          this.approvazioneEmails = '';
        } else {
          this.$toast.add({ severity: 'error', summary: 'Errore', detail: response.data.message, life: 4000 });
        }
      })
      .catch(() => {
        this.$toast.add({ severity: 'error', summary: 'Errore', detail: this.$root.trans.salvataggio_errato, life: 3000 });
      });
    },
    async save(){
      // se sto lavorando come admin e quindi posso modificare il ticket
      // e se ho effettivamente modificato il ticket
      // come prima cosa salvo le informazioni
      if(this.ruolo == 'admin' && this.ticket_modificato){
          const data = {
            id: this.ticket.id,
            ticketingtipo_id: this.ticket.ticketingtipo_id,
            ticketingpriorita_id: this.ticket.ticketingpriorita_id
          }
          try{
            const response = await axios.post('/admin/ticketing/dettagli/aggiorna', data);
            if(response.data.success){
              this.$toast.add({severity:'success', summary:this.$root.trans.ticket_aggiornato, life:5000});
              window.location.reload();
            }
          }catch (error) {
            this.$toast.add({severity:'error', summary:this.$root.trans.ticket_aggiornato_fallito, life:5000});
          }
          this.ticket_modificato = false;
      }
      if(this.ruolo == 'admin' && this.scadenza_modificata){
        const data = {
          id: this.ticket.id,
          data_scadenza_manuale: this.ticket.sla
        }
        try {
          const response = await axios.post('/admin/ticketing/scadenza/aggiorna', data);
          if(response.data.success){
            this.$toast.add({severity:'success', summary:this.$root.trans.sla_aggiornata, life:5000});
          }
        }catch (error) {
          this.$toast.add({severity:'error', summary:this.$root.trans.sla_aggiornata_fallita, life:5000});
        }
        this.scadenza_modificata = false;
      }

      console.log(this.$refs.thread_form.infoRisposta,this.$refs.thread_form.infoNota)

      if(this.$refs.thread_form.infoRisposta.messaggio.trim() != '' || this.$refs.thread_form.infoNota.nota_interna.trim() != '' || this.$refs.thread_form.infoRisposta.ore != 0 || this.$refs.thread_form.infoRisposta.ticketingstato_id != this.ticket.ticketingstato_id){
        //this.$refs.thread_form.submitForm();
        this.$refs.thread_form.checkOre();
      }

    }
  }
}

</script>
